// Styles
import '../scss/main.scss';

// Import asset images
import './images';

// Import javascript
import SmoothScroll from './partials/smoothScroll';

import siteMenu from './partials/siteMenu';
import stickyProjectHeader from './partials/stickyProjectHeader';
import sliders from './partials/sliders';
import downloadFiles from './partials/downloadFiles';
import modal from './partials/modal';
import aptsLogic from './partials/aptsLogic';
import statusModule from './partials/statusModule';
import timelineModule from './partials/timelineModule';
import cookies from './partials/cookies';
import customTrackingEvents from './partials/customTrackingEvents';
import { ContactForm } from './partials/contactForm';

import cssVars from 'css-vars-ponyfill';

document.addEventListener("DOMContentLoaded", function () {
    if(/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
        cssVars({});
    }

    siteMenu();
    stickyProjectHeader();
    sliders();
    downloadFiles();
    modal();
    aptsLogic();
    statusModule();
    timelineModule();
    cookies();
    customTrackingEvents();

    window.addEventListener('resize', function () {
        document.documentElement.style.setProperty('--vh', window.innerHeight * 0.01 + 'px');
    });

    new SmoothScroll('a[href^="#"]:not([href~="open-popup"])', { header: '#header' });

    let contactSections = document.querySelectorAll('.section-contact-form');

    [].forEach.call(contactSections, function (section) {
        new ContactForm(section);
    });
});